<template> 
  <div class="product-container" :style="styleObject">
    <div class="product xocdia">
      <!-- <GameHeader :data="data"/>
      <div class="playbox-container">
        <div class="all-bet">
          <div class="bg-qs">
            <div>
              <div class="bet-qs">
                <div class="bet-1">
                  <div
                    class="item-bet-1"
                  />
                  <FlipResult
                    :table="table"
                    :game-state="gameState"
                    class="item-bet-2"
                    :score="score"
                  />
                  <div
                    class="item-bet-3"
                  />
                </div>
                <div class="bet-2">
                  <div
                    class="item-bet-4"
                  />
                  <div
                    class="item-bet-5"
                  />
                  <div
                    class="item-bet-6"
                  />
                  <div
                    class="item-bet-7"
                  />
                  <div
                    class="item-bet-8"
                  />
                </div>
              </div>
              <div class="img-bet-qs"></div>
            </div>
          </div>
        </div>
        <GameFooter />
      </div> -->
    </div>
    <button @click.prevent="setGameState('LOADING')">LOADING</button>
    <button @click.prevent="setGameState('BETTING')">BETTING</button>
    <button @click.prevent="setGameState('RESULTING')">RESULTING</button>
    <button @click.prevent="setGameState('WAITING_NEW_GAME')">WAITING_NEW_GAME</button>
    <button @click.prevent="setGameState('WAITING_RESULT')">WAITING_RESULT</button>
    <button @click.prevent="setGameState('LOCKING')">LOCKING</button>
    <button @click.prevent="setGameState('STOP')">STOP</button>

    <CanvasTest :game-state="gameState" style="top: 10" @showResult="showResult"/>
    
  </div>
</template>

<script>
import FlipResult from '@components/xocdia/flip-result.vue';
import Canvas from "@components/common/canvas.vue";
import GameHeader from '@components/common/game-header.vue';
import GameBody from '@components/xocdia/body.vue';
import GameFooter from '@components/xocdia/footer.vue';
import CanvasTest from '@/src/components/xocdia/canvas-xd-result.vue';
import { GAMESTATE } from '@config/constants.js';
import { calculateChipStack } from '@utils/chip.js';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    GameHeader, GameBody, GameFooter, FlipResult, Canvas, CanvasTest
  },
  props: {
    windowFocus: { type: Number, default: 0 },
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    tableId: { type: String, default: "" },
    data: { type: Object, default: () => ({})},
    styleObject: { type: Object, default: () => ({})},
  },
  data() {
    return {
      isShowResult: false,
      timeout: 0,
      gameState: GAMESTATE.LOADING,
      isHighlightResult: false,
      newRound: 0,
      timeBet: 0,
      jackpot: 0,
      odds: {},
      state: '',
      round: 12234,
      score: {
        playerCard1Number: "J",
        playerCard1Suit: 1,
        playerCard2Number: "K",
        playerCard2Suit: 2,
        playerCard3Number: "",
        playerCard3Suit: 3,
        playerCardTotal: 11,
        bankerCard1Number: 2,
        bankerCard1Suit: 4,
        bankerCard2Number: 3,
        bankerCard2Suit: 2,
        bankerCard3Number: "A",
        bankerCard3Suit: 3,
        bankerCardTotal: 10,
        result: "TIE",
        bigSmall: "BIG",
        double: "P_DUAL",
      },
    }
  },
  watch: {
    windowFocus: function(newVal, oldVal){
      console.log('[watch] windowFocus', newVal);
      this.gameState = 'STOP';
    }
  },
  mounted() {
    const value = 1235;
    calculateChipStack(value);
  },
  methods: {
    setGameState(value) {
      console.log('setGameState', value);
      this.gameState = value;
      this.isShowResult = false;
    },
    showResult() {
      this.isShowResult = true;
      console.log('[flip-result] - showResult', this.isShowResult);
    },
  }
}
</script>

<style>

</style>
